import my_axios, { get_axios_data } from "@/pcomponents/common/axios";

function ManageArea(props: any) {
  let myProps = {
    listOpt: {},
    list: (inData: any) => { },
    open_send_order_msg_popup: (inData: any) => { },
    ListComponentRef: null,
    ...props
  };
  let { listOpt, ListComponentRef } = myProps;

  const go_change_order_state_by_ajax = (inData: any) => {
    let default_select_rows = [];
    if (ListComponentRef.current) {
      default_select_rows = ListComponentRef.current.getSelectedRows();
    }
    let opt_obj = {
      state: "",
      select_rows: default_select_rows,
      ...inData
    };
    let select_rows = opt_obj.select_rows;

    if (select_rows.length == 0) {
      alert("선택된 주문이 없습니다.");
      return;
    }

    let order_pri_val_arr = [];
    for (let i = 0; i < select_rows.length; i++) {
      let row_order_info = select_rows[i];
      order_pri_val_arr.push(row_order_info["row_pri_val"]);
    }

    if (confirm(select_rows.length + "개의 주문 상태를 변경 하시겠습니까?") === false) {
      return;
    }

    let form_json_data: any = {
      order_pri_val_arr: order_pri_val_arr,
      change_state: opt_obj.state,
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/main/shop/shop_order/state_change', form_json_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          alert(response.data["msg"]);
          myProps.list({});
        } else {
          alert(response.data["msg"]);
        }
      });
  };
  let now_state = listOpt.s_state || "";

  const get_manage_btns = () => {
    let btns: any = "";
    if (now_state == "request") {
      btns = (
        <>
          <button className="btn btn-dark" onClick={() => { go_change_order_state_by_ajax({ state: "accept" }); }}>준비중</button>
          <button className="btn btn-dark" onClick={() => { go_change_order_state_by_ajax({ state: "move" }); }}>배송중</button>
          <button className="btn btn-dark" onClick={() => { go_change_order_state_by_ajax({ state: "complete" }); }}>완료</button>
        </>
      );
    } else if (now_state == "accept") {
      btns = (
        <>
          <button className="btn btn-dark" onClick={() => { go_change_order_state_by_ajax({ state: "move" }); }}>배송중</button>
          <button className="btn btn-dark" onClick={() => { go_change_order_state_by_ajax({ state: "complete" }); }}>완료</button>
        </>
      );
    } else if (now_state == "move") {
      btns = (
        <>
          <button className="btn btn-dark" onClick={() => { go_change_order_state_by_ajax({ state: "complete" }); }}>완료</button>
        </>
      );
    } else if (now_state == "complete") {
      btns = (
        <>
          <button className="btn btn-dark" onClick={() => { go_change_order_state_by_ajax({ state: "accept" }); }}>준비중</button>
        </>
      );
    }
    return btns;
  };
  let btns_tag = get_manage_btns();

  return (
    <div className="my_flex_right">
      <button className="btn btn-dark"
        onClick={() => {
          myProps.list({ is_excel_down: true, now_page: 1 });
        }}>엑셀</button>
      {now_state == "move" && (
        <button className="btn btn-dark"
          onClick={() => {
            myProps.open_send_order_msg_popup({});
          }}
        >배송시작 메세지 발송</button>
      )}
      {btns_tag &&
        <span>상태변경:</span>
      }
      {get_manage_btns()}
    </div>
  );
};
export default ManageArea;